
import ForgetEmail from './Admin/auth/ForgetEmail';
import './App.css';
import { toast, ToastContainer } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './Admin/Dashboard/AdminDashboard';
import CustomerDashboard from './Customer/Dashboard/CustomerDashboard';
import Otp from './Admin/auth/Otp';
import ForgetChange from './Admin/auth/ForgetChange';
import FourZeroFour from './ErrorPage/FourZeroFour';
import Error2 from './ErrorPage/Error2';
import { useEffect, useState } from 'react';
import Cookies from "js-cookie"
import { getCompanyDetails, getNotification, getSidebarPermissionHRMS } from './Redux/action/NavbarAction';
import Beatloader from './Common/Loaders/Beatloader';
import Unauthorized from './Common/Unauthorized/Unauthorized';
import { useDispatch, useSelector } from 'react-redux';
import PageNotFound404 from './Common/Unauthorized/PageNotFound404';
import LoginHRMS from './Admin/auth/LoginHRMS';
import CustomerLogin from './Customer/auth/CustomerLogin';
// import Error500 from './ErrorPage/Error500';
// import Error500 from './ErrorPage/Error500';
function App() {
  useEffect(() => {
    const bootstrap = require('bootstrap');
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((dropdownToggleEl) => {
      new bootstrap.Dropdown(dropdownToggleEl);
    });
  }, []);


  //role and permission check
  const dispatch = useDispatch();
  let tokenCookie = Cookies.get("token");
  let userIdCookie = Cookies.get("flexichain_user_id");
  let customerTokenCookie = Cookies.get("customertoken");
  const [token, setToken] = useState(tokenCookie);
  const [user_id, setUser_id] = useState(userIdCookie);
  const [customerToken, setCustomerToken] = useState(customerTokenCookie);
  const [accessedModules, setAccessedModules] = useState([]);
  const [accessedPermission, setAccessedPermission] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [roleInfo, setRoleInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [showProduction, setShowProduction] = useState(false);
  const [showTransport, setShowTransport] = useState(false);

  const baseURL = typeof window !== 'undefined' ? window.location.origin : '';

  //if show the effect on production,then make variable true
  // useEffect(() => {
  //   if (baseURL) {
  //     if (baseURL === 'http://localhost:3000' || baseURL === "https://flexichain.co.in" || baseURL === "https://flexichains.com" || baseURL === "https://hrms.flexichains.com") {
  //       setShowProduction(false);
  //     } else {
  //       setShowProduction(true);
  //     }
  //   } else {
  //     setShowProduction(false);
  //   }
  // }, [baseURL]);

  //if show the effect on production,then make variable true
  useEffect(() => {
    if (baseURL) {
      if (baseURL === "https://flexichain.co.in/" || baseURL==="https://committedhrms.flexichains.com" ) {
        setShowTransport(false);
      } else {
        setShowTransport(true);
      }
    } else {
      setShowTransport(false);
    }
  }, [baseURL])


  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;

  const { loadingSidebarPermissionHRMSApi,
    sidebarPermissionHRMSData,
    sidebarPermissionHRMSDataError,
    notificationData,
    loadingCompanyDetail,
    CompanyDetailData,
    CompanyDetailDataError
  } = useSelector(state => state?.NavbarReducer);

  const checkToken = () => {
    const cookieToken = Cookies.get('token');
    const cookieUserId = Cookies.get('flexichain_user_id');
    if (cookieToken !== token) {
      setToken(cookieToken);  // Update the state if token changes
    }
    if (cookieUserId !== user_id) {
      setUser_id(cookieUserId);
    }

    const customerCookieToken = Cookies.get("customertoken");
    if (customerCookieToken !== customerToken) {
      setCustomerToken(customerCookieToken);
    }
  };



  // Listen for token changes in the app
  useEffect(() => {
    const interval = setInterval(() => {
      checkToken();
    }, 500);
    return () => clearInterval(interval);
  }, [token]);





  useEffect(() => {
    dispatch(getCompanyDetails());
    if (token && user_id) {
      dispatch(getSidebarPermissionHRMS(token, user_id));
      dispatch(getNotification(token, user_id))
    }
  }, [token, user_id, dispatch]);

  const refreshNotification = () => {
    if (token && user_id) {
      dispatch(getNotification(token, user_id))
    }
  }


  useEffect(() => {
    if (sidebarPermissionHRMSData) {

      if (sidebarPermissionHRMSData?.modules) {
        let module_arr = [];
        sidebarPermissionHRMSData?.modules?.map(mod => {
          if (mod.assign_module_role) {
            module_arr.push(mod.short_name)
          }
        });
        setAccessedModules(module_arr);
      }

      if (sidebarPermissionHRMSData?.permissions) {
        let permission_arr = [];
        sidebarPermissionHRMSData?.permissions?.map(perm => {
          if (perm?.assign_permission_role) {
            permission_arr.push(perm.short_name);
          }
        });
        setAccessedPermission(permission_arr);
      }

      if (sidebarPermissionHRMSData) {
        let object = {
          user_id: sidebarPermissionHRMSData?.user_id,
          name: sidebarPermissionHRMSData?.name,
          email: sidebarPermissionHRMSData?.email,
          profile_image: sidebarPermissionHRMSData?.avatar,
        }
        setUserInfo(object);
      }

      if (sidebarPermissionHRMSData?.role) {
        setRoleInfo(sidebarPermissionHRMSData?.role);
      }

    };

    if (loadingSidebarPermissionHRMSApi) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    if (sidebarPermissionHRMSDataError) {
      toast.error(sidebarPermissionHRMSDataError);
      Cookies.remove('flexichain_user_id');
      Cookies.remove('token');
      window.location.reload();
    }
  }, [loadingSidebarPermissionHRMSApi, sidebarPermissionHRMSData, sidebarPermissionHRMSDataError])


  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          <Route index element={<Navigate to="login" />} />
          {/* <Route exact path='admin-dashboard/*' element={<AdminDashboard />}></Route> */}
          <Route exact path='customer-dashboard/*' element={<CustomerDashboard CompanyDetailData={CompanyDetailData} showProduction={showProduction}/>}></Route>
          {/* <Route exact path='login' element={<Login />}></Route> */}
          <Route exact path='login' element={<LoginHRMS loadingCompanyDetail={loadingCompanyDetail} CompanyDetailData={CompanyDetailData} />}></Route>
          <Route exact path='/customer/login' element={<CustomerLogin loadingCompanyDetail={loadingCompanyDetail} CompanyDetailData={CompanyDetailData}/>}></Route>
          <Route exact path='hrms-login' element={<LoginHRMS />}></Route>
          <Route exact path='forget-otp' element={<Otp />}></Route>
          <Route exact path='forget-email' element={<ForgetEmail />}></Route>
          <Route exact path='change-password' element={<ForgetChange />}></Route>
          <Route exact path='error-404' element={<FourZeroFour />}></Route>
          <Route exact path='error-500' element={<Error2 />}></Route>
          <Route path="*" element={<PageNotFound404 />} />

          <Route exact path='flexichain/*' element={
            (token && user_id) ? accessedModules.length && accessedPermission.length ? (
              <AdminDashboard accessedModules={accessedModules} accessedPermission={accessedPermission} userInfo={userInfo} roleInfo={roleInfo} user_id={user_id} showProduction={showProduction} refreshNotification={refreshNotification} notificationData={notificationData} CompanyDetailData={CompanyDetailData} loadingCompanyDetail={loadingCompanyDetail} showTransport={showTransport} />
            ) : (
              <Beatloader />
            ) : <AdminDashboard />
          } />
          <Route exact path='/unauthorized-access' element={<Unauthorized />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
